import React from 'react';
//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';
//@ts-ignore
import Collapsible from 'react-collapsible';

/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  lines?: any;
  active?: boolean;
  columns?: any;
  site?: any;
}
interface IState {
  lineContentActive?: any;
  animating?:boolean;
  active?:boolean;
  openedCollapsibleCategoryIndex?:any;
  openedLineIndex?:any;
}

class HeaderLineMenu extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  componentDidUpdate = () =>{
    if(this.props.active && !this.state.lineContentActive && !this.state.animating){
      this.setState({
        active:true,
        animating:true,
        lineContentActive:false
      },()=>{
        setTimeout(() => {
          this.setState({
            animating:false,
            lineContentActive:true
          })
        }, 10);
      })
    }
    if(!this.props.active && !this.state.animating){
      this.setState({
        animating:true,
        lineContentActive:false
      },()=>{
        setTimeout(() => {
          this.setState({
            animating:false,
            active:false
          })
        }, 500);
      })
    }
  }

  public toggleCollabsibleCategory = (e:any,lineIndex:any, collapsibleCategoryIndex:any) =>{
    if(lineIndex == this.state.openedLineIndex && collapsibleCategoryIndex == this.state.openedCollapsibleCategoryIndex){
      this.setState({
        openedCollapsibleCategoryIndex:-1,
        openedLineIndex:-1
      })
    } else{
      this.setState({
        openedCollapsibleCategoryIndex:collapsibleCategoryIndex,
        openedLineIndex:lineIndex
      })
    }
  }

  public render(): JSX.Element {
    let menuActiveClass:string = "";
    let menuContentActiveClass:string = "";
    let textColor:any = '#000';
    let backgroundColor:any = "#fff";
    let site = 'hosports';
    if(typeof window !== "undefined"){
      if(window.location){
        if(window.location.href){
          if(window.location.href.indexOf('hyperlite') != -1){
            site = 'hyperlite'
          }
        }
      }
    }
    if(this.props.site == 'hyperlite'){
      textColor = '#fff';
      backgroundColor = "#111";
    }
    if(this.state.active){
      menuActiveClass = "active";
    }

    if(this.state.lineContentActive && this.props.active){
      menuContentActiveClass = "active";
    }
    return (
      <div className={"header-line-menu-wrapper "+menuActiveClass}>
       <div className={"header-line-menu "+menuContentActiveClass}  style={{backgroundColor:backgroundColor}}>
         {this.props.lines &&
           <>
            <div className="row">
              {this.props.lines.map((line:any, index:any) =>{
                let lineIndex:any = index;
                return(
                  <div className={this.props.columns ? columnCoversionDictionary[this.props.columns]:"line-column"}>
                    {site == 'hosports' ?
                      <a href={line.link}>
                        <img className="full-width line-image" src={line.image} />
                        {line.title && <p className="line-title" style={{color:textColor}}><b>{line.title}</b></p>}
                      </a>
                    :
                    <a href={line.link}>
                      <div className="background-image-fill" style={{position:"relative","backgroundImage":"url("+line.image+")"}}>
                          <img className="full-width line-image" style={{opacity:0}} src={line.image} />
                          <div style={{position:'absolute', top:0,left:0,right:0,bottom:0, display:'flex', alignItems:'center', justifyContent:'center'}}>
                            {line.title && <h3 className="line-title" style={{color:textColor, display:'none'}}><b>{line.title}</b></h3>}
                          </div>
                      </div>
                    </a>
                    }
                    <div className="line-submenu">
                      {line.links && line.links.map((link:any) =>{
                        return(
                          <span>
                            <a className="line-link subheading" href={link.url}>{link.text}</a>
                          </span>
                        )
                      })}
                      {line.collabsibleCategoryLinks && line.collabsibleCategoryLinks.map((category:any,index:any) =>{
                        let collapsibleCategoryIndex: any  = index;
                        let opened:any = false;
                        if(this.state.openedLineIndex == lineIndex ){
                          if(this.state.openedCollapsibleCategoryIndex == collapsibleCategoryIndex){
                           opened = true
                          }
                        }

                        return(
                          <span>
                            {(category.links && category.links.length > 0) ?
                              <span>
                                <div className="row" style={{width:'100%',display:'flex',alignItems:'center'}}>
                                  <div style={{flex:1}}>
                                    <a className="line-link" href={category.url}>{category.text}</a>
                                  </div>
                                  <img onClick={(e:any)=>this.toggleCollabsibleCategory(e,lineIndex,collapsibleCategoryIndex)} style={{cursor:'pointer'}} className="line-accordion-plus-icon" src={GeneralAssetUrl+'plus-white.png'} />
                                </div>
                                <Collapsible open={opened} trigger={category.text}>
                                  {category.links && category.links.map((link:any) =>{
                                    return(
                                      <span>
                                        <a className="line-link subheading" href={link.url}>{link.text}</a>
                                      </span>
                                    )
                                  })}
                                </Collapsible>
                              </span>
                            :
                              <a className="line-link" href={category.url}>{category.text}</a>
                            }

                          </span>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
           </>
         }
       </div>
      </div>
    );
 }
}

 export default HeaderLineMenu;

 export const columnCoversionDictionary:any = {
   six:'small-12 medium-2',
   five:'line-column',
   four:'small-12 medium-3',
   three:'small-12 medium-4',
   two:'small-12 medium-6',
   one:'small-12 medium-12'
 };
